import { IProfile } from 'common/modules/ReactShared';

declare const window: any;
let previousProfileId: IProfile['id'] | null = null;

export const messagesReconnect = (id: number | null = null): void => {
  if (previousProfileId === id) {
    return;
  }

  previousProfileId = id;

  if (typeof window !== 'undefined' && window.LINGU_MESSAGES) {
    try {
      window.LINGU_MESSAGES.reconnect();
    } catch (e) {
      /* empty */
    }
  }
};
